// Envoi d'événements au pixel ChatGPT Ads (snippet `oaiq` chargé dans
// app/layout.tsx). Noms et formes des événements standards :
// https://learn.chatgpt.com/ads/supported-events

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void
  }
}

type EventData =
  | { type: "customer_action"; amount?: number; currency?: string }
  | { type: "contents"; amount?: number; currency?: string }
  | { type: "custom" }

type EventOptions = { event_id?: string; custom_event_name?: string }

export function trackOaiq(event: string, data: EventData, options: EventOptions = {}) {
  if (typeof window === "undefined" || !window.oaiq) return
  window.oaiq("measure", event, data, {
    event_id: `${options.custom_event_name ?? event}_${crypto.randomUUID()}`,
    ...options,
  })
}
